// (c) Copyright Mimic Networks, Inc. 2024
//
import React, { useState } from 'react'
import { Input, ConfigProvider } from 'antd'
import theme from '../theme'
import clsx from 'clsx'

const InputField = ({
  label,
  onChange,
  regexMatch,
  regexError,
  containerClassName,
  ...props
}) => {
  const [errorMessage, setErrorMessage] = useState(null)

  const handleChange = (e) => {
    if (!regexMatch || !e.target.value || e.target.value?.match(regexMatch)) {
      onChange(e.target.value)
      setErrorMessage(null)
    } else {
      setErrorMessage(regexError || `Field does not match ${regexMatch}`)
    }
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            activeBorderColor: theme.colors.mimic.black,
            lineWidth: 2,
          },
        },
      }}
    >
      <div className={clsx('flex flex-col space-y-1', containerClassName)}>
        {label && <div className="text-xs">{label}</div>}
        <Input
          className="w-full"
          onChange={handleChange}
          status={errorMessage ? 'error' : null}
          {...props}
        />
        {errorMessage && (
          <div className="text-red-500 text-xs">{errorMessage}</div>
        )}
      </div>
    </ConfigProvider>
  )
}

export default InputField
